var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#FFBB00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0847 17.1357L7.97371 13.8201C7.60383 13.4259 6.97828 13.4248 6.60702 13.8177C6.26603 14.1785 6.26503 14.7425 6.60475 15.1046L11.0847 19.8792L21.3994 8.88618C21.7371 8.52624 21.7371 7.96584 21.3994 7.6059C21.0299 7.21217 20.4048 7.21203 20.0352 7.60558L11.0847 17.1357Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCircle);
export default __webpack_public_path__ + "static/media/yellowCircle.b55f55b9cf79f77e0f81d95ee1dac622.svg";
export { ForwardRef as ReactComponent };